/* eslint-disable no-nested-ternary */
/* eslint-disable complexity */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FaBars } from 'react-icons/fa';

import {
  propTypesActiveDocMeta,
  propTypeslocalization,
} from '../../../constants/Proptypes';
import { propTypesNavigation } from './Header.proptypes';

import { NavBar } from './NavBar';
import { RootLogo } from './RootLogo';

import { debounce } from './debounce';

import { DocumentType } from '../../../constants/Enums';
import * as S from './Header.styles';

export const Header = ({
  navigation,
  activeDocMeta,
  localization,
  isNavbarHidden,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [isHeaderDisplayed, setIsHeaderDisplayed] = useState(true);
  const [isSearchBarDisplayed, setIsSearchBarDisplayed] = useState(false);
  const {
    data: {
      searchbar_placeholder: placeholder,
      event_searchbar_placeholder: eventPlaceholder,
    } = {},
  } = localization || '';

  const handleScroll = debounce(() => {
    const currentScrollPos =
      typeof window !== 'undefined' ? window.pageYOffset : 0;

    setIsHeaderDisplayed(
      (prevScrollPos > currentScrollPos &&
        prevScrollPos - currentScrollPos > 10) ||
        currentScrollPos < 85
    );

    setPrevScrollPos(currentScrollPos);
  }, 100);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll);

      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [prevScrollPos, isHeaderDisplayed, handleScroll]);

  if (!navigation || !activeDocMeta) {
    return null;
  }

  const { data: document } = navigation || {};
  const { alternateLanguages, lang, type } = activeDocMeta || {};

  const isWebsite =
    type === DocumentType.PAGE ||
    type === DocumentType.CONTACT ||
    type === DocumentType.NOTFOUND ||
    type === DocumentType.HOMEPAGEWEB ||
    type === DocumentType.PRICING ||
    type === DocumentType.CONTACT;

  const isEvent =
    type === DocumentType.EVENTGALLERY ||
    type === DocumentType.EVENTTAG ||
    type === DocumentType.EVENT;

  const documentType = isWebsite ? 'website' : isEvent ? 'event' : 'blog';

  return (
    <S.Container isHeaderDisplayed={isHeaderDisplayed}>
      <S.Wrapper>
        <S.BurgerNav>
          <RootLogo lang={lang} />
          {!isNavbarHidden && (
            <S.BurgerButton onClick={() => setIsVisible(!isVisible)}>
              <FaBars />
            </S.BurgerButton>
          )}
          {!isNavbarHidden && (
            <NavBar
              isMobile={false}
              alternateLanguages={alternateLanguages}
              isVisible={isVisible}
              isSearchBarDisplayed={isSearchBarDisplayed}
              setIsSearchBarDisplayed={setIsSearchBarDisplayed}
              placeholder={
                documentType === 'event' ? eventPlaceholder : placeholder
              }
              document={document}
              lang={lang}
              documentType={documentType}
              localization={localization}
            />
          )}
        </S.BurgerNav>
      </S.Wrapper>
      <S.HorizontalLine />
      <NavBar
        isMobile={true}
        alternateLanguages={alternateLanguages}
        isVisible={isVisible}
        isSearchBarDisplayed={isSearchBarDisplayed}
        setIsSearchBarDisplayed={setIsSearchBarDisplayed}
        placeholder={documentType === 'event' ? eventPlaceholder : placeholder}
        document={document}
        lang={lang}
        documentType={documentType}
        localization={localization}
      />
    </S.Container>
  );
};

Header.propTypes = {
  /**
   * Language data from the current Prismic document.
   */
  activeDocMeta: PropTypes.shape(propTypesActiveDocMeta),
  /**
   * Hide the navbar links, the breadcrumb and the promo banner if true.
   */
  isNavbarHidden: PropTypes.bool,
  /**
   * Prismic Localization object.
   */
  localization: PropTypes.shape(propTypeslocalization),
  /**
   * Navigation document.
   */
  navigation: PropTypes.shape(propTypesNavigation),
};
